import { testId } from '@lojinha/helpers';
import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import styled, { createGlobalStyle } from 'styled-components';
import { tabNavigationStyle } from '../../helpers/tabNavigationStyle';
import { Box, Button, Stack } from '../..';
import { CloseCircle } from '../../components/Icons/close-circle';
import { Text } from '../Text';
import { theme as DSTheme } from '../../theme';
const bugFullHeightFixSnippet = `
  html, body {
    max-height: 100%;
  }
`;
const GlobalStyle = createGlobalStyle `
  ${({ isOpen }) => {
    if (!isOpen) {
        return '';
    }
    return bugFullHeightFixSnippet;
}}

  ${({ noOverlay }) => {
    if (noOverlay) {
        return `
      .drawer {
        .ReactModal {
          &__Overlay {
            overflow: hidden;
            background: transparent;
            height: 100vh;
            pointer-events: none;
          }

          &__Content {
            box-shadow: 0px 0px 12px rgb(0 0 0 / 8%);
            pointer-events: all;
          }
        }
      }
    `;
    }
    return `
      .ReactModalOpenClass{
        overflow: hidden;
        .drawer {
          .ReactModal {
            &__Overlay {
              background-color: rgba(0, 0, 0, 0.4);
            }
          }
        }
      }
    `;
}}

  .ReactModal {
    &__Overlay {
      &--after-open {
        opacity: 1;
        transition: opacity 200ms ease-in-out;
      }

      &--before-close {
        opacity: 0;
        transition: opacity 150ms ease-out 100ms;
      }
    }

    &__Content {
      width: 100%;
      max-width: 29rem;
      flex-direction: column;
      transform: translateX(100%);
      transition: transform 250ms linear;

      &--after-open {
        transform: translateX(0);
        transition: transform 250ms linear;
      }

      &--before-close {
        transform: translateX(100%);
        transition: transform 250ms linear;
      }
    }
  }
`;
const CloseButtonContainer = styled.button `
  align-items: center;
  background: none;
  border: 2px solid ${({ theme }) => theme.colors.transparent};
  cursor: pointer;
  display: flex;
  margin-left: auto;

  ${tabNavigationStyle}
`;
const Header = styled(Box) `
  ${({ highlighted, theme }) => highlighted
    ? `
        align-items: center;
        border-bottom: 1px solid ${theme.colors.gray200};
        padding: ${theme.space.x0} ${theme.space.x16};
        min-height: ${theme.space.x56};

        ${theme.media.above('md')} {
          padding: ${theme.space.x24} ${theme.space.x40};
          min-height: ${theme.space.x96};
        }

        ${theme.media.below('sm')} {
          padding: ${theme.space.x16} ${theme.space.x16};
        }
      `
    : `
        padding: ${theme.space.x24} ${theme.space.x40} 0;

        ${theme.media.below('sm')} {
          padding: ${theme.space.x16} ${theme.space.x16} 0;
        }
      `}
`;
const CloseButton = ({ onClick, closeText, ariaLabelText }) => (React.createElement(CloseButtonContainer, { onClick: onClick, ...testId('close-drawer') },
    React.createElement(Stack, { layout: "horizontal", margin: "x8" },
        closeText && (React.createElement(Text, { isBold: true, textSize: "x1", textTransform: "uppercase" }, closeText)),
        React.createElement(CloseCircle, { size: "x20", "aria-label": ariaLabelText }))));
const customStyles = {
    content: {
        top: 0,
        right: 0,
        border: 0,
        padding: 0,
        height: '100%',
        left: 'initial',
        borderRadius: DSTheme.borderRadius.x0,
        overflow: 'hidden',
        zIndex: 1,
        display: 'flex',
    },
    overlay: {
        backgroundColor: '',
        zIndex: 1000,
    },
};
export const Drawer = ({ children, closeText, ariaLabelText, heading, isOpen, onRequestClose, highlightedHeader, hasCloseButton, noOverlay, ...rest }) => {
    useEffect(() => {
        ReactModal.setAppElement('body');
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyle, { isOpen: isOpen, noOverlay: noOverlay }),
        React.createElement(ReactModal, { ...rest, bodyOpenClassName: "ReactModalOpenClass", closeTimeoutMS: 250, isOpen: !!isOpen, onRequestClose: onRequestClose, style: customStyles, shouldCloseOnOverlayClick: hasCloseButton && !noOverlay, portalClassName: "drawer", ariaHideApp: false, aria: { modal: true } },
            React.createElement(Header, { alignItems: "flex-end", display: "flex", justifyContent: "flex-start", highlighted: !!highlightedHeader },
                React.createElement(Text, { as: "div", textSize: ['x2', 'x3'], isBold: true }, heading),
                hasCloseButton && (React.createElement(CloseButton, { onClick: onRequestClose, closeText: closeText, ariaLabelText: ariaLabelText }))),
            children,
            !hasCloseButton && closeText && (React.createElement(Box, { px: ['x16', 'x40'], paddingBottom: "x40" },
                React.createElement(Button, { onClick: onRequestClose, color: "success", isOutlined: true, isBlock: true }, closeText))))));
};
Drawer.defaultProps = {
    hasCloseButton: true,
};
//# sourceMappingURL=index.js.map